import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { DisablingWarningDialogContent } from './DisablingWarningDialogContent'

interface IProps {
  isShowDialog: boolean

  disablingComment: string
  minCommentLength: number
  flagTag: string

  onApply: (value: string) => Promise<void>
  onCancel: () => void
}

export const DisablingWarningDialog = ({
  isShowDialog,

  disablingComment,
  minCommentLength,
  flagTag,

  onApply,
  onCancel,
}: IProps) => {
  const contentProps = useMemo(() => {
    return { disablingComment, minCommentLength, flagTag, onApply, onCancel }
  }, [disablingComment, minCommentLength, flagTag, onApply, onCancel])

  return (
    <ModalDialog
      size="xs"
      show={isShowDialog}
      content={DisablingWarningDialogContent}
      contentProps={contentProps}
      onClose={onCancel}
    />
  )
}
